export const logo = [
  {
    id: 1,
    name: "Blue Cross Blue Shield",
    image: "https://www.bcbs.com/dA/cec184ec-9008-4a98-bd75-b5d2304fb861",
    url:" https://www.bcbs.com/",
    
  },
  {
    id: 2,
    name:"UnitedHealth Group",
    image:"https://imgs.search.brave.com/c63zVoZrOqhSRHvDkAy_FhkiKA-f4D7EZQscwd7MplU/rs:fit:920:480:1/g:ce/aHR0cHM6Ly93d3cu/cG5ncGxheS5jb20v/d3AtY29udGVudC91/cGxvYWRzLzMvVW5p/dGVkSGVhbHRoLUdy/b3VwLUxvZ28tUE5H/LUNsaXBhcnQtQmFj/a2dyb3VuZC5wbmc",
    url:"https://www.unitedhealthgroup.com/",
  },
  {
    id: 3,
    name: "Anthem",
    image: "https://imgs.search.brave.com/NrIiwx1LL9bL9PvRcSgozOM79fzBr78ViLs4sTWAqQc/rs:fit:567:378:1/g:ce/aHR0cHM6Ly9pMS53/cC5jb20vd3d3LmV5/ZW9uZXZhLmNvbS93/cC1jb250ZW50L3Vw/bG9hZHMvMjAxOC8w/MS8yNjE2Nzg5NF8x/MzcwNjcyNTU5NzEw/MTU2XzU4NDQ2NDc4/OTc1MjQ1NTY0NjVf/bi5qcGc_Zml0PTU2/NyUyQzM3OCZzc2w9/MQ",
    url:"https://www.anthem.com/",
  },
  {
    id: 4,
    name: "Bank of America",
    image: "https://www.bankofamerica.com/content/images/ContextualSiteGraphics/Logos/en_US/logos/colored_flagscape-v2.png",
    url:"https://www.bankofamerica.com/",
  },
  {
    id: 5,
    name: "Wells Fargo",
    image: "https://www.logo.wine/a/logo/Wells_Fargo/Wells_Fargo-Logo.wine.svg",
    url:"https://www.wellsfargo.com/",
  },
  {
    id: 6,
    name: "AT&T",
    image: "https://imgs.search.brave.com/Vl8t6uYyev8Vc8Hpr47MzlghV4d7_86yqeYgkGpKdbA/rs:fit:1024:768:1/g:ce/aHR0cHM6Ly9hcmth/bnNhc2Zvb2RiYW5r/Lm9yZy93cC1jb250/ZW50L3VwbG9hZHMv/MjAxOS8wNS9BVFQt/bG9nby0yMDE2LWxv/Z290eXBlLTEwMjR4/NzY4LTEtMS5wbmc",
    url:"https://www.att.com/", 
  },
  {
    id: 7,
    name: "CareSource",
    image: "https://www.caresource.com/wp-content/themes/the-next-generation/assets/images/cs-tertiary-primary.svg",
    url:"https://www.caresource.com/",
  },
  {
    id: 8,
    name: "Centene Corporation",
    image: "https://imgs.search.brave.com/CQjoM_S_oYKYf8oehoed6eR1KFW-0q1pFm01ONuwcTQ/rs:fit:240:240:1/g:ce/aHR0cHM6Ly93d3cu/YW1lcmljYW5iYW5r/aW5nbmV3cy5jb20v/d3AtY29udGVudC90/aW10aHVtYi90aW10/aHVtYi5waHA_c3Jj/PWh0dHBzOi8vd3d3/Lm1hcmtldGJlYXQu/Y29tL2xvZ29zL2Nl/bnRlbmUtY28tbG9n/by5wbmc_dj0yMDIy/MTAyNDEwMzk0MSZ3/PTI0MCZoPTI0MCZ6/Yz0y",
    url:"https://www.centene.com/",
  },
  {
    id: 9,
    name: "Beacon",
    image: "https://imgs.search.brave.com/uJIWwMHXlDs2hEp4sbmVz9UqSkfReJ4iK-TlJBEr5cU/rs:fit:1200:627:1/g:ce/aHR0cHM6Ly9pLnBp/bmltZy5jb20vb3Jp/Z2luYWxzLzUwLzU0/LzcwLzUwNTQ3MGZk/NTMwMzc3MmUyYWM3/YjE0YzBjNGJkNmZi/LmpwZw",
    url:"https://www.beaconhealthoptions.com/", 
  },
  {
    id: 10,
    name: " DXC Technology  ",
    image: "https://imgs.search.brave.com/U6lgNKQlWsHA9aOhfVvuMu-oLkNc5_dMC1CwiIvLyxo/rs:fit:360:170:1/g:ce/aHR0cHM6Ly9sb2dv/ZGl4LmNvbS9sb2dv/Lzk2ODY3My5wbmc",
    url:"https://dxc.com/us/en",
  },
  {
    id: 11,
    name: "Evolent Health",
    image: "https://www.evolent.com/themes/custom/evolent/images/logo.png",
    url:"https://www.evolenthealth.com/",
  },
  {
    id: 12,
    name: "TEKsystems",
    image: "https://www.teksystems.com/-/media/teksystems/images/logos/teksystems-logo.svg?iar=0&hash=06A094A67567DCB386D6FA4BE4F2BDD0",
    url:"https://www.teksystems.com/",
  },
  {
    id: 13,
    name: "Sogeti",
    image: "https://logotyp.us/files/sogeti.svg",
    url:"https://www.sogeti.com/",
  },
  {
    id: 14,
    name: "Randstad",
    image: "https://seeklogo.com/images/R/randstad-logo-579A9DB8A9-seeklogo.com.png",
    url:" https://www.randstad.com/",
  },
  {
    id: 15,
    name: "Catalyst Solutions",
    image: "https://images.squarespace-cdn.com/content/v1/65b919e9cc626732b995bb0e/f9ab91eb-b459-4492-a909-a548f616783e/Catalyst_logo_dark_green.png?format=1500w",
    url:" https://catalystsolutions.com/",
  },

];